exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#my-profile{font-family:\"Roboto\", Helvetica, sans-serif;padding-top:40px;padding-bottom:100px}#my-profile label{font-weight:400;color:#4A4A4A}#my-profile .s1-avatar{width:130px}#my-profile .s1-change-password{cursor:pointer;text-decoration:underline}#my-profile .cancel-btn{margin-right:10px;background-color:#fff}#my-profile .my-profile-block{position:relative;margin-bottom:10px}#my-profile .my-profile-block .my-profile-btn{font-size:11px;padding:0;background:transparent;border:1px solid #ccc;border-radius:2px;position:absolute;bottom:-17px}#my-profile .my-profile-block .my-profile-btn .fa{width:17px}#my-profile .my-profile-block .my-profile-btn--save{right:15px;border-color:#00A4EF;color:#00A4EF}#my-profile .my-profile-block .my-profile-btn--cancel{right:36px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/User/my-profile.scss
// module id = 1888
// module chunks = 32